export const TRANSITION_DURATION = 300 // ms
export const BULLET_LIMIT = 5
